import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import FreeGuidePage from './pages/FreeGuidePage';
import MainGuidePage from './pages/MainGuidePage';
import AdvancedGuidePage from './pages/AdvancedGuidePage';
import DIYStarterKitPage from './pages/DIYStarterKitPage';
import CommunityPage from './pages/CommunityPage';
import CommunityPortal from './pages/CommunityPortal';
import AccessPage from './pages/AccessPage';
import BlogListPage from './pages/BlogListPage';
import BlogPostPage from './pages/BlogPostPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelPage from './pages/PaymentCancelPage';
import AdminDashboard from './pages/AdminDashboard';
import UnsubscribePage from './pages/UnsubscribePage';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/free-guide" element={<FreeGuidePage />} />
          <Route path="/products/guide" element={<MainGuidePage />} />
          <Route path="/products/advanced-guide" element={<AdvancedGuidePage />} />
          <Route path="/products/diy-starter-kit" element={<DIYStarterKitPage />} />
          <Route path="/products/community" element={<CommunityPage />} />
          <Route path="/community/portal" element={<CommunityPortal />} />
          <Route path="/access" element={<AccessPage />} />
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/permaculture-saves-money" element={<BlogPostPage />} />
          <Route path="/payment/success" element={<PaymentSuccessPage />} />
          <Route path="/payment/cancel" element={<PaymentCancelPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
